module.exports = __webpack_public_path__ + "static/dybbuk-a86bbe61778b16958ec47f0b1e596c02.png";